<div class="project">
  <table style="width: 100%;">
    <thead>
    <tr>
      <th scope="col" style="width: 30px;"></th>
      <th scope="col" style="width: 60px;"></th>
      <th scope="col" i18n="@@Title">Title</th>
      <th scope="col" i18n="@@Details">Details</th>
      <th scope="col" style="width: 60px;" i18n="@@Last Updated">Last Updated</th>
      <th scope="col" style="width: 30px;"></th>
    </tr>
    </thead>
    <tbody>
      <ng-container class="projectDrafts" *ngFor="let draft of project.drafts">
        <tr class="projectDraft" [ngClass]="draft === project.primaryDraft ? 'primary' : ''" *ngIf="!searchString || (searchString && draft.title && draft.title.toLowerCase().includes(searchString.toLowerCase()))">
          <td></td>
          <td>
            <div style="display: inline-block;display: inline-block; overflow: hidden; height: 100%; min-width: 190px; min-height: 310px; max-height: 310px; position: relative;">
              <app-project-book-cover-image *ngIf="project.primaryBook" [book]="project.primaryBook"></app-project-book-cover-image>
              <app-project-draft-cover-image *ngIf="!project.primaryBook && project.primaryDraft" [draft]="project.primaryDraft"></app-project-draft-cover-image>
            </div>
          </td>
          <td><button mat-raised-button style="width:100%" color="primary" type="button" (click)="editingDetails = 'DRAFT';"><ng-container>{{draft.title}}</ng-container></button></td>
          <td>
            <span *ngIf="draft.bindingType" i18n="@@Binding">Binding</span><span *ngIf="draft.bindingType">: {{draft.bindingType}}</span>
            <span *ngIf="draft.interiorType"> · </span>
            <span *ngIf="draft.interiorType" i18n="@@Interior">Interior</span><span *ngIf="draft.interiorType">: {{draft.interiorType}}</span>
            <span *ngIf="draft.draftBody?.numPages"> · {{draft.draftBody.numPages}} </span><span *ngIf="draft.draftBody?.numPages" i18n="@@pages">pages</span>
            <span *ngIf="draft.draftCover?.laminateType"> · {{draft.draftCover.laminateType}}</span>
          </td>
          <td>{{draft.lastUpdate | date: 'MM/dd/yy hh:mm:ss'}}</td>
          <td>
            <div class="folderDropdown">
              <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton"><mat-icon>more_vert</mat-icon></button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="moveToNewProject(draft, 'DRAFT')">
                  <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move to New Project">Move to New Project</ng-container>
                </button>
                <button mat-menu-item (click)="moveToProject(draft, 'DRAFT')">
                  <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move to Project">Move to Project</ng-container>
                </button>
                <button mat-menu-item (click)="makePrimary(draft, 'DRAFT')">
                  <mat-icon>heart</mat-icon><span>&nbsp;</span><ng-container i18n="@@Make Primary">Make Primary</ng-container>
                </button>
                <button mat-menu-item (click)="delete(draft, 'DRAFT')">
                  <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Draft">Delete Draft</ng-container>
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container class="projectDraft" [ngClass]="book === project.primaryBook ? 'primary' : ''" *ngFor="let book of project.books">
        <tr *ngIf="!searchString || (searchString && book.title && book.title.toLowerCase().includes(searchString.toLowerCase()))">
          <td></td>
          <td>
            <div style="display: inline-block;">
              <app-project-book-cover-image *ngIf="project.primaryBook" [book]="project.primaryBook"></app-project-book-cover-image>
              <app-project-draft-cover-image *ngIf="!project.primaryBook && project.primaryDraft" [draft]="project.primaryDraft"></app-project-draft-cover-image>
            </div>
          </td>
          <td><button mat-raised-button style="width:100%" color="primary" type="button" (click)="editingDetails = 'BOOK';"><ng-container>{{book.title}}</ng-container></button></td>
          <td>
            <span *ngIf="book.bindingType" i18n="@@Binding">Binding</span><span *ngIf="book.bindingType">: {{book.bindingType}}</span>
            <span *ngIf="book.interiorType"> · </span>
            <span *ngIf="book.interiorType" i18n="@@Interior">Interior</span><span *ngIf="book.interiorType">: {{book.interiorType}}</span>
            <span *ngIf="book.body?.numPages"> · {{book.body.numPages}} </span><span *ngIf="book.body?.numPages" i18n="@@pages">pages</span>
            <span *ngIf="book.cover?.laminateType"> · {{book.cover.laminateType}}</span>
          </td>
          <td>{{book.lastUpdate | date: 'MM/dd/yy hh:mm:ss'}}</td>
          <td>
            <div class="folderDropdown">
              <button mat-button [matMenuTriggerFor]="menu" class="manageFolderButton"><mat-icon>more_vert</mat-icon></button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="moveToNewProject(book, 'BOOK')">
                  <mat-icon>create_new_folder</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move to New Project">Move to New Project</ng-container>
                </button>
                <button mat-menu-item (click)="moveToProject(book, 'BOOK')">
                  <mat-icon>drive_file_move</mat-icon><span>&nbsp;</span><ng-container i18n="@@Move to Project">Move to Project</ng-container>
                </button>
                <button mat-menu-item (click)="makePrimary(book, 'BOOK')">
                  <mat-icon>heart</mat-icon><span>&nbsp;</span><ng-container i18n="@@Make Primary">Make Primary</ng-container>
                </button>
                <button mat-menu-item (click)="delete(book, 'BOOK')">
                  <mat-icon>delete</mat-icon><span>&nbsp;</span><ng-container i18n="@@Delete Book">Delete Book</ng-container>
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
